import { render, staticRenderFns } from "./AProviderList.vue?vue&type=template&id=3d6fb63d&scoped=true"
import script from "./AProviderList.vue?vue&type=script&lang=js"
export * from "./AProviderList.vue?vue&type=script&lang=js"
import style0 from "./AProviderList.vue?vue&type=style&index=0&id=3d6fb63d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6fb63d",
  null
  
)

export default component.exports